
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as SideDrawerIconComponent } from "./side-drawer-icon.svg";

export const SideDrawerIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <SideDrawerIconComponent {...props} />;
};
